import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="admin-shell flex items-center justify-center min-h-screen">
      <div className="text-[color:var(--sky-admin-muted)]">Loading…</div>
    </div>
  );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
